import { httpRequest } from "@services/http";
import { AudienceDefinition } from "@models/audienceDefinition.model";
import { AudienceDefinitionSerializer } from "@models/serializers/audienceDefinitionSerializer";

export interface CreateAudiencePayload {
  name: string;
  rules: Record<string, any>;
  audience_preset_id?: number;
  // Only needed when the engagement's campaigns target different populations.
  population_segment_id?: number;
}

export class CommandCreateAudienceDefinition {
  async run(engagementId: number, payload: CreateAudiencePayload): Promise<AudienceDefinition> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/audiences/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });

    const serializer = new AudienceDefinitionSerializer();
    return serializer.deserialize(response);
  }
}